import { Button } from 'antd'
import useModalShow from '../../elements/Hooks/useModalShow'
import PaymentCont from '../../elements/Payment/PaymentCont'
import React from 'react'

function PaymentModal(props) {
  const { buttonTitle = 'Pay', disabled, clearSelection } = props
  const { visible, onShow, onCancel: _onCancel } = useModalShow()

  async function onCancel() {
    clearSelection && clearSelection()
    await _onCancel()
  }

  return (
    <div>
      <Button type="primary" size={'small'} disabled={disabled} onClick={onShow}>
        {buttonTitle}
      </Button>
      <PaymentCont {...{ visible, onShow, onCancel, ...props }} />
    </div>
  )
}

export default PaymentModal
